import PropTypes from 'prop-types';
import React from 'react';

import Returns from './Returns';
import Done from './Done';
import Pay from './Pay';
import PaymentInit from './PaymentInit';
import ViewHistory from './ViewHistory';

function Payments({ onStepSet, step }) {
  return step === 0 ? (
    <ViewHistory onStepSet={onStepSet} />
  ) : step === 1 ? (
    <PaymentInit onStepSet={onStepSet} />
  ) : step === 2 ? (
    <Pay onStepSet={onStepSet} />
  ) : step === 3 ? (
    <Returns onStepSet={onStepSet} />
  ) : step === 4 ? (
    <Done onStepSet={onStepSet} />
  ) : (
    <ViewHistory onStepSet={onStepSet} />
  );
}

Payments.propTypes = {
  onStepSet: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
};

export default Payments;
